<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-flex flex-column h-100">
    <!-- header -->
    <div class="vehicle-profile-header cph-justify-space-between">
        <div class="widget-title">{{widgetData?.title}}</div>
        <div *ngIf="(masterAttData?.value||masterAttData?.value===0) && !isloader && !isError">
            <img alt="Info" matTooltipClass="tooltip-new-line" [matTooltip]="infoHoverLabel()" class="cursor h-20"
                src="../../../../assets/images/info-icon.svg">
        </div>
    </div>
    <!-- chart area -->
    <div class="chart-box-wrapper" *ngIf="masterAttData?.value && !isloader && !isError">
        <div *ngFor="let gauge of clutchPadRul; let i=index" class="w-100">
            <div class="h-100 w-100">
                <app-gauge-chart [gaugeData]="gauge" [index]="i"></app-gauge-chart>
            </div>
        </div>
    </div>
    <div class="place-center h-100 no-data-style" *ngIf="!masterAttData?.value || isError">
        No Data
    </div>
</div>